import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-supplementary-material-list',
  templateUrl: './supplementary-material-list.component.html',
  styleUrls: ['./supplementary-material-list.component.scss']
})
export class SupplementaryMaterialListComponent implements OnInit {
  @Input() course;
  @Input() layout: 'card' | 'inline';

  constructor() { }

  ngOnInit() {
  }

}
